import { render, staticRenderFns } from "./PhoneFormaterinput.vue?vue&type=template&id=153da131&scoped=true"
import script from "./PhoneFormaterinput.vue?vue&type=script&lang=js"
export * from "./PhoneFormaterinput.vue?vue&type=script&lang=js"
import style0 from "./PhoneFormaterinput.vue?vue&type=style&index=0&id=153da131&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153da131",
  null
  
)

export default component.exports